import { useState } from "react";
import "./CategoryFilter.css";
import { Button, Form } from "react-bootstrap";

export default function CategoryFilter(props) {
  // collapsible list of all available categories

  const [categoriesCollapsed, setCategoriesCollapsed] = useState(false);

  const filterHeader = (
    <>
    <Form.Label
      className="fw-bold mb-0"
      style={{ display: "flex", justifyContent: "space-between"}}
    >
      Categories
      <div >

      {props.showReturnButton && <i
        className="bi bi-arrow-return-left me-3" 
        style={{cursor: "pointer", fontSize: "small" }}
        onClick={props.handleReturnToParentCategory}
      ></i>}
      {categoriesCollapsed ? <i onClick={() => setCategoriesCollapsed(false)} className="bi bi-plus pointer"></i> : <i onClick={() => setCategoriesCollapsed(true)} className="bi bi-dash pointer"></i>}
    
      </div>
    </Form.Label>
    </ >
  );

  if (!props?.categoryOptions || props?.categoryOptions.length < 1) {
    return <>{filterHeader}</>;
  }
  return (
    <>
            
      {filterHeader}
          {/* <p  style={{fontWeight: "light", fontStyle: "italic"}} >{"/Kayaking/Kayaks"}    </p> */}
          <div className={categoriesCollapsed ? "hide-element" : ""}>

      {props.categoryOptions.map((category) => {
        return (
          <Button
            key={category?._id}
            variant="none"
            className="category-filter-button"
            onClick={() => props.handleSelectNewCategory(category)}
          >
            {category?.name}
          </Button>
        );
        
      })}
      </div>
    </>
  );
}


